import { Image } from "expo-image";
import { Text } from "react-native-paper";
import Box from "../Box";
import Loader from "../Loader";
import { useOnboarding } from "./OnboardingProvider";
import CategoryGrid, { type CategoryItem } from "./components/CategoryGrid";
import { OnboardingBox } from "./components/OnboardingBox";

type Props = {
	title: string;
	description?: string;
};

export const OnboardingCategoryScreen = ({ title, description }: Props) => {
	const { categories, selectedCategoryId, onSelectCategory } = useOnboarding();

	if (!categories) {
		return <Loader />;
	}

	const items: CategoryItem[] = categories.map((category) => ({
		id: category.id,
		title: category.name,
		image: (
			<Image
				source={{ uri: category.icon }}
				style={{ width: 100, height: 100 }}
				contentFit="contain"
			/>
		),
	}));

	return (
		<Box flex={1} gap={16}>
			<OnboardingBox>
				<Box gap={14}>
					<Text variant="titleLarge">{title}</Text>
					{description ? <Text variant="bodyMedium">{description}</Text> : null}
				</Box>
			</OnboardingBox>
			<Box flex={1}>
				<CategoryGrid
					items={items}
					selectedId={selectedCategoryId}
					onSelect={onSelectCategory}
				/>
			</Box>
		</Box>
	);
};
